export default __webpack_public_path__ + "e948761f73621fafff6e6f210d4ed742.svg";